<!-- ============== Visiting Seva Summary and Requirements Modal ============== -->

<div class="fullscreen-popup" *ngIf="ApplicationTypeIdConstant.VISITING_SEVA == data.ApplicationTypeId">
  <div class="popup-content">
    <div class="header-section">
      <h2 class="main-title">{{ getTranslation('modal.visitingSeva.title') }}</h2>
      <p class="subtitle">{{ getTranslation('modal.visitingSeva.subtitle') }}</p>
    </div>

    <div class="content-section">
      <!-- Prerequisites Section -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.common.prerequisitesTitle') }}</h3>
        <ul class="requirements-list">
          <li>{{ getTranslation('modal.visitingSeva.req.age18+') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.req.sadhana1y') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.req.intensive3y') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.req.language') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.req.health') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.req.centreParticipation') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.req.sevaParticipation') }}</li>
        </ul>
      </div>

      <!-- Children Age 5-12 Section -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.visitingSeva.children5to12.title') }}</h3>
        <p class="note">{{ getTranslation('modal.common.ageNote') }}</p>
        <ul class="requirements-list">
          <li>{{ getTranslation('modal.visitingSeva.children5to12.req1') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.children5to12.req2') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.children5to12.req3') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.children5to12.req4') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.children5to12.req5') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.children5to12.req6') }}</li>
        </ul>
        <p class="contact-note">{{ getTranslation('modal.common.guardianshipNote') }}</p>
      </div>

      <!-- Children Age 13-17 Section -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.visitingSeva.children13to17.title') }}</h3>
        <p class="note">{{ getTranslation('modal.common.ageNote') }}</p>
        <ul class="requirements-list">
          <li>{{ getTranslation('modal.visitingSeva.children13to17.req1') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.children13to17.req2') }}</li>
          <li>{{ getTranslation('modal.visitingSeva.children13to17.req3') }}</li>
        </ul>
        <p class="contact-note">{{ getTranslation('modal.common.guardianshipNote') }}</p>
      </div>

      <!-- Example Section -->
      <div class="section example-section">
        <h3 class="section-title">{{ getTranslation('modal.common.exampleTitle') }}</h3>
        <p>{{ getTranslation('modal.visitingSeva.example.p1') }}</p>
        <p>{{ getTranslation('modal.visitingSeva.example.p2') }}</p>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn popup-btn-cancel" (click)="back()">{{ getTranslation('button.back') }}</button>
      <button class="popup-btn popup-btn-proceed" (click)="proceed()">{{ getTranslation('button.proceed') }}</button>
    </div>
  </div>
</div>

<!-- ============== Gurukula Student Summary and Requirements Modal ============== -->

<div class="fullscreen-popup" *ngIf="ApplicationTypeIdConstant.GURUKULA_SEVA == data.ApplicationTypeId">
  <div class="popup-content">
    <div class="header-section">
      <h2 class="main-title">{{ getTranslation('modal.gurukula.title') }}</h2>
      <p class="subtitle">{{ getTranslation('modal.gurukula.subtitle') }}</p>
    </div>

    <div class="content-section">
      <!-- Prerequisites Section -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.common.prerequisitesTitle') }}</h3>
        <ul class="requirements-list">
          <li>{{ getTranslation('modal.gurukula.req.age18+') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.sadhana2y') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.intensive3y') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.sweetSurprise') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.understandingSeva') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.visitingSeva') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.sixMonths') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.language') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.health') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.centreParticipation2y') }}</li>
          <li>{{ getTranslation('modal.gurukula.req.sevaParticipation1y') }}</li>
        </ul>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn popup-btn-cancel" (click)="back()">{{ getTranslation('button.back') }}</button>
      <button class="popup-btn popup-btn-proceed" (click)="proceed()">{{ getTranslation('button.proceed') }}</button>
    </div>
  </div>
</div>

<!-- ============== Pilgrimage to the Heart Retreat Summary and Requirements Modal ============== -->

<div class="fullscreen-popup" *ngIf="ApplicationTypeIdConstant.PTH == data.ApplicationTypeId">
  <div class="popup-content">
    <div class="header-section">
      <h2 class="main-title">{{ getTranslation('modal.pth.title') }}</h2>
      <p class="subtitle">{{ getTranslation('modal.pth.subtitle') }}</p>
    </div>

    <div class="content-section">
      <!-- Prerequisites Section -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.common.prerequisitesTitle') }}</h3>
        <ul class="requirements-list">
          <li>{{ getTranslation('modal.pth.req.age18+') }}</li>
          <li>
            {{ getTranslation('modal.pth.req.sadhana2y') }}
            <br />
            <span class="note">
              ({{ getTranslation('modal.pth.req.sadhana1yNote') }})
            </span>
          </li>
          <li>{{ getTranslation('modal.pth.req.intensive3y') }}</li>
          <li>{{ getTranslation('modal.pth.req.dailyMeditation') }}</li>
          <li>{{ getTranslation('modal.pth.req.language') }}</li>
          <li>{{ getTranslation('modal.pth.req.health') }}</li>
          <li>{{ getTranslation('modal.pth.req.dakshina') }}</li>
          <li>{{ getTranslation('modal.pth.req.centreParticipation2y') }}</li>
          <li>{{ getTranslation('modal.pth.req.sevaParticipation1y') }}</li>
        </ul>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn popup-btn-cancel" (click)="back()">{{ getTranslation('button.back') }}</button>
      <button class="popup-btn popup-btn-proceed" (click)="proceed()">{{ getTranslation('button.proceed') }}</button>
    </div>
  </div>
</div>



<!-- ============== Siddha Yoga Family Retreat Summary and Requirements Modal ============== -->

<div class="fullscreen-popup" *ngIf="ApplicationTypeIdConstant.FAMILY_RETREAT == data.ApplicationTypeId">
  <div class="popup-content">
    <div class="header-section">
      <h2 class="main-title">{{ getTranslation('modal.familyRetreat.title') }}</h2>
      <p class="subtitle">{{ getTranslation('modal.familyRetreat.subtitle') }}</p>
    </div>

    <div class="content-section">
      <!-- Prerequisites for Parents -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.familyRetreat.parents.title') }}</h3>
        <ul class="requirements-list">
          <li>{{ getTranslation('modal.familyRetreat.parents.sadhana2y') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.parents.intensive3y') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.parents.hindi') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.parents.health') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.parents.centreParticipation1y') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.parents.sevaParticipation1y') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.parents.dakshina') }}</li>
        </ul>
      </div>

      <!-- Prerequisites for Children -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.familyRetreat.children.title') }}</h3>
        <ul class="requirements-list">
          <li>{{ getTranslation('modal.familyRetreat.children.age10to17') }}</li>
          <li>
            {{ getTranslation('modal.familyRetreat.children.example') }}
          </li>
          <li>{{ getTranslation('modal.familyRetreat.children.hindi') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.children.motivation') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.children.intensive') }}</li>
          <li>{{ getTranslation('modal.familyRetreat.children.satsang') }}</li>
        </ul>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn popup-btn-cancel" (click)="back()">{{ getTranslation('button.back') }}</button>
      <button class="popup-btn popup-btn-proceed" (click)="proceed()">{{ getTranslation('button.proceed') }}</button>
    </div>
  </div>
</div>




<!-- ============== Siddha Yoga Retreat for Young Adults Summary and Requirements Modal ============== -->

<div class="fullscreen-popup" *ngIf="ApplicationTypeIdConstant.KYPR == data.ApplicationTypeId">
  <div class="popup-content">
    <div class="header-section">
      <h2 class="main-title">{{ getTranslation('modal.kypr.title') }}</h2>
      <p class="subtitle">{{ getTranslation('modal.kypr.subtitle') }}</p>
    </div>

    <div class="content-section">
      <!-- Prerequisites Section -->
      <div class="section">
        <h3 class="section-title">{{ getTranslation('modal.common.prerequisitesTitle') }}</h3>
        <ul class="requirements-list">
          <li>
            {{ getTranslation('modal.kypr.req.age18to30') }}
            <br />
            <span class="note">
              {{ getTranslation('modal.kypr.req.ageExample') }}
            </span>
          </li>
          <li>{{ getTranslation('modal.kypr.req.sadhana1y') }}</li>
          <li>{{ getTranslation('modal.kypr.req.intensive3y') }}</li>
          <li>{{ getTranslation('modal.kypr.req.dailyMeditation') }}</li>
          <li>{{ getTranslation('modal.kypr.req.hindi') }}</li>
          <li>{{ getTranslation('modal.kypr.req.health') }}</li>
          <li>{{ getTranslation('modal.kypr.req.centreParticipation1y') }}</li>
          <li>{{ getTranslation('modal.kypr.req.sevaParticipation1y') }}</li>
        </ul>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn popup-btn-cancel" (click)="back()">{{ getTranslation('button.back') }}</button>
      <button class="popup-btn popup-btn-proceed" (click)="proceed()">{{ getTranslation('button.proceed') }}</button>
    </div>
  </div>
</div>

